import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from "@myenv/environment";

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactUsComponent implements OnInit {
  public contactEmail = environment.contactEmail;

  constructor() { }

  ngOnInit() {
  }

}
